var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.balance === 'inf')?_c('i',{staticClass:"far fa-infinity text-danger"}):[_c('span',{class:_vm.color},[_vm._v(_vm._s(_vm.$n(_vm.balance))+"%")])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }